(ns manage.slate-editor.common
  (:require [mate.core :as mc]))

;;
;; Macro content node specific data
;;
(def macro-content-node-type "macro-content")
(def macro-content-node-regex #"[^\{\}]*")

(def macro-node-type "macro")

(defn macro-node-regex [] (-> #"\$\{([^\{\}]*)\}"
                              ;; The "d" flag is for returning the subgroups' indices during regex matching.
                              (mc/re-with-flags "d")))

;;
;; Mentions specific data
;;

(def mention-node-type "mention")

(defn mentions-node-regex [] (-> #"@(\d+)"
                                 ;; The "d" flag is for returning the subgroups' indices during regex matching.
                                 (mc/re-with-flags "d")))

;;
;; Query param node specific data
;;
(def query-param-attribute-node-type "query-param-attribute")
(def query-param-attribute-node-regex #"[^\?&#{}\n=]+")

(def query-param-value-node-type "query-param-value")
(def query-param-value-node-regex #"[^\?&#\n=]+")

(def query-param-node-type "query-param")

(defn query-param-node-regex [] (-> #"([^\?&#{}\n=]+)=([^\?&#\n=]+)"
                                    ;; The "d" flag is for returning the subgroups' indices during regex matching.
                                    (mc/re-with-flags "d")))

#_(re-find (query-param-node-regex) "http://www.example.com/?key=val#anchor")
